import { http } from '../helpers/http'

const findAll = () => {
  return http.get('/natures')
}

const findActionNatures = () => {
  return http.get('/actions/natures')
}

const findAllInformationNatures = () => {
  return http.get('/informations/natures')
}

const find = id => {
  //
}

const createInformationNature = informationNature => {
  return http.post('/information/natures', informationNature, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

const updateInformationNature = (id, informationNature) => {
  return http.post(`/information/nature/${id}`, informationNature, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

const deleteInformationNature = id => {
  return http.delete(`/information/nature/${id}`)
}

const createActionNature = actionNature => {
  return http.post('/action/natures', actionNature, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

const updateActionNature = (id, actionNature) => {
  return http.post(`/action/nature/${id}`, actionNature, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

const deleteActionNature = id => {
  return http.delete(`/action/nature/${id}`)
}

const createEventNature = eventNature => {
  return http.post('/event/natures', eventNature, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

const updateEventNature = (id, eventNature) => {
  return http.post(`/event/nature/${id}`, eventNature, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

const deleteEventNature = id => {
  return http.delete(`/event/nature/${id}`)
}

export const natureService = {
  findAll,
  findActionNatures,
  findAllInformationNatures,
  find,
  createInformationNature,
  updateInformationNature,
  deleteInformationNature,
  createActionNature,
  updateActionNature,
  deleteActionNature,
  createEventNature,
  updateEventNature,
  deleteEventNature
}
